<template>
  <section
      class="voice-video"
  >
    <div class="blex w-full relative bg-black lg:pt-80">
      <loco-modal
          :value="currentIndex !== null"
          @input="inputModal"
      >
        <div class="slide-image cursor-pointer w-full"
             @click="currentIndex = null"
        >
          <div class="voice-image blex" v-if="currentIndex === 0">
            <img src="@/assets/images/pages/main/voiceVideo/voice1.png" alt="" class="w-full lg:w-3/4">
          </div>
          <div class="voice-image blex" v-else-if="currentIndex === 1">
            <img src="@/assets/images/pages/main/voiceVideo/voice2.png" alt="" class="w-full lg:w-3/4">
          </div>
          <div class="voice-image blex" v-else-if="currentIndex === 2">
            <img src="@/assets/images/pages/main/voiceVideo/voice3.png" alt="" class="w-full lg:w-3/4">
          </div>
        </div>
      </loco-modal>

      <div class="blex justify-start w-full px-16 lg:w-7/10">
        <div class="text-white font-bold text-2xl lg:text-6xl blex pt-100 lg:pt-60 bottom-gradient pb-12">
          VOICE & VIDEO CHAT
        </div>
      </div>
      <div class="w-full px-16 lg:w-7/10">
        <div class="text-white font-medium text-3xs lg:text-base leading-xs pt-60 pb-40 w-full lg:w-3/5">
          {{ $t('chatting.2') }}
        </div>
        <div class="w-full blex-right">
          <div class="text-white font-medium text-3xs lg:text-base leading-xs pb-40 w-full lg:w-2/5 text-right">
            {{ $t('chatting.3') }}
          </div>
        </div>
      </div>

      <!-- @todo : slider 적용      -->
      <div class="w-full px-16 lg:px-0 lg:w-7/10 z-1">
        <carousel-3d
            :controls-visible="true"
            :startIndex="0"
            :clickable="true"
            :width="$store.state.windowWidth < 1200 ? 250 : 800"
            :height="$store.state.windowWidth < 1200 ? 180 : 540"
            :inverseScaling="400"
            :border="0">
          <slide :index="0"
          >
            <img @click="clickImg(0)"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/voiceVideo/voice1.png') : require('@/assets/images/pages/main/voiceVideo/mVoice1.png')"
                 alt=""
                 class="h-full object-cover cursor-pointer">
          </slide>
          <slide :index="1"
          >
            <img @click="clickImg(1)"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/voiceVideo/voice2.png') : require('@/assets/images/pages/main/voiceVideo/mVoice2.png')"
                 alt=""
                 class="h-full object-cover cursor-pointer">
          </slide>
          <slide :index="2"
          >
            <img @click="clickImg(2)"
                 :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/voiceVideo/voice3.png') : require('@/assets/images/pages/main/voiceVideo/mVoice3.png')"
                 alt=""
                 class="h-full object-cover cursor-pointer">
          </slide>
        </carousel-3d>
      </div>

      <div class="content-wrap">
        <div class="content">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto" class="waves">
              <defs>
                <path id="gentle-wave"
                      d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
              </defs>
              <g class="parallax">
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".1" x="48" y="0"
                     fill="rgb(0,0,0, 0.1)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".1" x="48" y="3"
                     fill="rgba(255,255,255, 0.1)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".1" x="48" y="5"
                     fill="rgba(0,0,0, 0.1)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".1" x="48" y="7"
                     fill="rgba(255,255,255, 0.1)"></use>
              </g>
            </svg>
          </div>
        </div>
        <div class="content">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto" class="waves">
              <defs>
                <path id="gentle-wave"
                      d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
              </defs>
              <g class="parallax">
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".1" x="48" y="0"
                     fill="rgb(0,0,0, 0.5)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".3" x="48" y="3"
                     fill="rgba(255,255,255, 0.1)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".2" x="48" y="5"
                     fill="rgba(0,0,0, 0.5)"></use>
                <use xlink:href="#gentle-wave" stroke="#fff" stroke-opacity=".3" x="48" y="7"
                     fill="rgba(255,255,255, 0.1)"></use>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import LocoModal from './LocoModal'

export default {
  name: 'VoiceVideo',
  components: {LocoModal},
  data: () => ({
    currentIndex: null,
    imageCount: 0,
    loadedImageCount: 0
  }),
  methods: {
    clickImg(index) {
      this.currentIndex = index
    },
    inputModal(val) {
      if (!val) {
        this.currentIndex = null
      }
    }
  },
  watch: {
    loadedImageCount(val) {
      // if (this.imageCount === val && this.$scrollTrigger) {
      //   this.$scrollTrigger.refresh()
      // }
    }
  },
  mounted() {
    const images = this.$el.querySelectorAll('img')
    this.imageCount = images.length
    images.forEach(img => {
      if (img.complete) {
        this.loadedImageCount++
      } else {
        img.addEventListener('load', () => this.loadedImageCount++)
      }
    })
  }

}
</script>

<style scoped lang="scss">
section::v-deep {
  height: calc(var(--vh, 1vh) * 160);

  @media (max-width: 1280px) {
    height: calc(var(--vh, 1vh) * 150);
  }

  @media (max-width: 1024px) {
    height: calc(var(--vh, 1vh) * 120);
  }

  .slide-image {
    position: absolute;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 10;
    display: none;
    justify-content: center;
    align-items: center;

    &.clicked {
      display: flex;
    }

    .voice-image {
      position: relative;
      width: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: flex;
      justify-content: center;
      align-items: center;

      &::after {
        content: '';
        position: absolute;
        background-image: url("~@/assets/images/icon/close.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        width: 48px;
        height: 48px;
        right: 11.5%;
        top: -3%;
      }

    }

    //.close {
    //  position: absolute;
    //  right: 16.5%;
    //  top: 19.5%;
    //}

    @media screen and (max-width: 1024px) {
      padding: 0 16px;
      .voice-image {
        width: 100%;

        &::after {
          width: 26px;
          height: 26px;
          right: -3%;
          top: -4%;
        }
      }

    }
  }

  .carousel-3d-container {
    .carousel-3d-controls {
      .prev {
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #fff;
        background: rgba(0, 0, 0, .5);

        &::after {
          content: '';
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 26px;
          background: url("~@/assets/images/pages/main/nft/leftArrow.svg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

        }


        span {
          display: none;
        }

        @media screen and (max-width: 1024px) {
          width: 30px !important;
          height: 30px !important;
          &::after {
            width: 16px;
            height: 20px;
          }
        }

      }

      .next {
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #fff;
        background: rgba(0, 0, 0, .5);
        //position: relative;

        &::after {
          content: '';
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 26px;
          background: url("~@/assets/images/pages/main/nft/rightArrow.svg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }

        span {
          display: none;
        }

        @media screen and (max-width: 1024px) {
          width: 30px !important;
          height: 30px !important;
          &::after {
            width: 16px;
            height: 20px;
          }
        }

      }

    }
  }

  .content-wrap {
    width: 100%;
    transform: translateY(-140%);
    z-index: 0;
  }

  .waves {
    position: relative;
    width: 100%;
    height: 30vh;
    margin-bottom: -7px; /*Fix for safari gap*/
    min-height: 100px;
    max-height: 150px;
    @media screen and (max-width: 1024px) {
      min-height: 50px;
      height: 70px;
    }
  }

  .content:nth-child(2) {
    transform: rotate(-180deg);

  }

  .parallax > use {
    animation: move 25s cubic-bezier(.55, .5, .45, .5) infinite;
  }

  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }

  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }

  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }

  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }

  @keyframes move {
    0% {
      transform: translate3d(-90px, 0, 0);
    }
    100% {
      transform: translate3d(85px, 0, 0);
    }
  }

}

</style>
